document.addEventListener('DOMContentLoaded', () => {
  const LOCAL_STORAGE_KEY = 'shopify_wishlist';
  const wishlistGrid = document.getElementById('wishlist-grid');
  const emptyMessage = document.getElementById('wishlist-empty-message');
  const toast = document.getElementById('wishlist-toast');
  const selectAllCheckbox = document.getElementById('wishlist-select-all');
  const selectAllContainer = document.querySelector('.wishlist-select-all-container');

  // Initialize wishlist array from localStorage
  let wishlist = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];

  // Update heart icons on the page
  const updateButtons = () => {
    const buttons = document.querySelectorAll('.card__wishlist:not(.wishlist-remove-btn)');
    buttons.forEach((btn) => {
      const handle = btn.getAttribute('data-product-handle');
      if (wishlist.includes(handle)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  };

  // Show Toast Notification
  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    setTimeout(() => {
      toast.classList.remove('show');
    }, 3000);
  };

  const removeProductFromWishlist = (handle, btnElement) => {
    wishlist = wishlist.filter(item => item !== handle);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(wishlist));
    updateButtons();

    if (wishlistGrid) {
      const card = btnElement.closest('.grid__item');
      if (card) card.remove();
      if (wishlist.length === 0) {
        emptyMessage.style.display = 'block';
        if (selectAllContainer) selectAllContainer.style.display = 'none';
      }
    }
  }

  // Handle wishlist button clicks
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.card__wishlist');
    if (btn) {
      e.preventDefault();
      const handle = btn.getAttribute('data-product-handle');
      if (!handle) return;

      if (btn.classList.contains('wishlist-remove-btn')) {
        // Handle trash icon click on wishlist page
        removeProductFromWishlist(handle, btn);
        showToast('Product removed from your wishlist.');
      } else {
        // Handle standard heart icon click
        if (wishlist.includes(handle)) {
          wishlist = wishlist.filter(item => item !== handle);
          btn.classList.remove('active');
          showToast('Product removed from your wishlist.');
        } else {
          wishlist.push(handle);
          btn.classList.add('active');
          showToast('Product has been added to your wishlist.');
        }
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(wishlist));
        updateButtons();
      }
    }

    // Handle Move to Cart click
    const moveToCartBtn = e.target.closest('.wishlist-move-to-cart-btn');
    if (moveToCartBtn) {
      e.preventDefault();
      const handle = moveToCartBtn.getAttribute('data-product-handle');
      const variantId = moveToCartBtn.getAttribute('data-variant-id');
      const cardInner = moveToCartBtn.closest('.grid__item');

      if (variantId) {
        const originalText = moveToCartBtn.textContent;
        moveToCartBtn.textContent = 'ADDING...';
        moveToCartBtn.disabled = true;

        let formData = {
          'items': [{
            'id': parseInt(variantId),
            'quantity': 1
          }]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then(response => {
            if (!response.ok) throw new Error('Error adding to cart');
            return response.json();
          })
          .then(data => {
            showToast('Product successfully added to cart!');
            // Remove from wishlist visually and in storage
            const removeBtn = cardInner.querySelector('.wishlist-remove-btn');
            if (removeBtn) {
              removeProductFromWishlist(handle, removeBtn);
            }

            // Optionally trigger Dawn theme cart update
            document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.open();
            }
          })
          .catch(error => {
            console.error('Error:', error);
            showToast('Failed to add product to cart.');
            moveToCartBtn.textContent = originalText;
            moveToCartBtn.disabled = false;
          });
      }
    }
  });

  // Handle Select All Checkbox
  const bulkActionsContainer = document.getElementById('wishlist-bulk-actions');
  const updateBulkActionsVisibility = () => {
    if (!bulkActionsContainer) return;
    const anyChecked = document.querySelector('.wishlist-item-checkbox:checked');
    bulkActionsContainer.style.display = anyChecked ? 'flex' : 'none';
  };

  // Handle View Toggles
  const viewToggles = document.querySelectorAll('.wishlist-view-btn');
  if (viewToggles.length === 2) {
    const listViewBtn = viewToggles[0];
    const gridViewBtn = viewToggles[1];
    
    listViewBtn.addEventListener('click', () => {
      listViewBtn.classList.add('active');
      gridViewBtn.classList.remove('active');
      if (wishlistGrid) {
        wishlistGrid.classList.add('list-view');
      }
    });

    gridViewBtn.addEventListener('click', () => {
      gridViewBtn.classList.add('active');
      listViewBtn.classList.remove('active');
      if (wishlistGrid) {
        wishlistGrid.classList.remove('list-view');
      }
    });
  }

  if (selectAllCheckbox) {
    selectAllCheckbox.addEventListener('change', (e) => {
      const isChecked = e.target.checked;
      const itemCheckboxes = document.querySelectorAll('.wishlist-item-checkbox');
      itemCheckboxes.forEach(checkbox => {
        checkbox.checked = isChecked;
      });
      updateBulkActionsVisibility();
    });
  }

  // Handle Individual Checkboxes (to uncheck "Select All" if one is unchecked)
  document.body.addEventListener('change', (e) => {
    if (e.target.classList.contains('wishlist-item-checkbox')) {
      updateBulkActionsVisibility();
      if (!e.target.checked && selectAllCheckbox) {
        selectAllCheckbox.checked = false;
      } else if (selectAllCheckbox) {
        // Check if all are checked
        const allCheckboxes = document.querySelectorAll('.wishlist-item-checkbox');
        const allChecked = Array.from(allCheckboxes).every(c => c.checked);
        selectAllCheckbox.checked = allChecked;
      }
    }
  });

  // Handle Bulk Delete
  const bulkDeleteBtn = document.getElementById('wishlist-bulk-delete');
  if (bulkDeleteBtn) {
    bulkDeleteBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const checkedBoxes = document.querySelectorAll('.wishlist-item-checkbox:checked');
      if (checkedBoxes.length === 0) return;

      checkedBoxes.forEach(checkbox => {
        const handle = checkbox.getAttribute('data-product-handle');
        const removeBtn = checkbox.closest('.grid__item').querySelector('.wishlist-remove-btn');
        if (removeBtn) {
          removeProductFromWishlist(handle, removeBtn);
        }
      });
      showToast('Selected products removed from your wishlist.');
      updateBulkActionsVisibility();
      if (selectAllCheckbox) selectAllCheckbox.checked = false;
    });
  }

  // Handle Bulk Add to Cart
  const bulkAddBtn = document.getElementById('wishlist-bulk-add');
  if (bulkAddBtn) {
    bulkAddBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const checkedBoxes = document.querySelectorAll('.wishlist-item-checkbox:checked');
      if (checkedBoxes.length === 0) return;

      const originalText = bulkAddBtn.textContent;
      bulkAddBtn.textContent = 'Adding...';
      bulkAddBtn.disabled = true;

      const itemsToAdd = [];
      checkedBoxes.forEach(checkbox => {
        const cardInner = checkbox.closest('.grid__item');
        const moveBtn = cardInner.querySelector('.wishlist-move-to-cart-btn');
        if (moveBtn) {
          const variantId = moveBtn.getAttribute('data-variant-id');
          if (variantId) {
            itemsToAdd.push({ id: parseInt(variantId), quantity: 1 });
          }
        }
      });

      if (itemsToAdd.length > 0) {
        let formData = { 'items': itemsToAdd };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        })
          .then(response => {
            if (!response.ok) throw new Error('Error adding to cart');
            return response.json();
          })
          .then(data => {
            showToast('Products successfully added to cart!');
            // Remove added items from wishlist
            checkedBoxes.forEach(checkbox => {
              const handle = checkbox.getAttribute('data-product-handle');
              const removeBtn = checkbox.closest('.grid__item').querySelector('.wishlist-remove-btn');
              if (removeBtn) removeProductFromWishlist(handle, removeBtn);
            });
            updateBulkActionsVisibility();
            if (selectAllCheckbox) selectAllCheckbox.checked = false;

            document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.open();
            }
          })
          .catch(error => {
            console.error('Error:', error);
            showToast('Failed to add products to cart.');
          })
          .finally(() => {
            bulkAddBtn.textContent = originalText;
            bulkAddBtn.disabled = false;
          });
      } else {
        bulkAddBtn.textContent = originalText;
        bulkAddBtn.disabled = false;
      }
    });
  }

  updateButtons();

  // Load products on the wishlist page
  if (wishlistGrid) {
    if (wishlist.length === 0) {
      emptyMessage.style.display = 'block';
      if (selectAllContainer) selectAllContainer.style.display = 'none';
    } else {
      wishlist.forEach((handle) => {
        fetch(`/products/${handle}?view=card`)
          .then(res => res.text())
          .then(html => {
            wishlistGrid.insertAdjacentHTML('beforeend', html);
            updateButtons(); // Re-run to ensure new cards have active state
          })
          .catch(err => console.error('Failed to load wishlist product', err));
      });
    }
  }
  // Handle Search Functionality
  const searchInput = document.querySelector('.wishlist-search-input');
  if (searchInput && wishlistGrid) {
    searchInput.addEventListener('input', (e) => {
      const searchTerm = e.target.value.toLowerCase().trim();
      const cards = wishlistGrid.querySelectorAll('.grid__item');
      
      cards.forEach(card => {
        const titleElement = card.querySelector('.card__heading');
        const title = titleElement ? titleElement.textContent.toLowerCase() : '';
        
        if (title.includes(searchTerm)) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  }
});
